import { useCallback, useEffect, useRef, useState } from "react";

const releasePreview = (url) => {
  if (url?.startsWith("blob:")) URL.revokeObjectURL(url);
};

// Il file appena caricato non appartiene ancora a un lotto: /api/uploads lo
// protegge correttamente fino al salvataggio. Mostra il data URL locale nel frattempo.
export const useLocalFilePreviews = () => {
  const filesRef = useRef(new Map());
  const [urls, setUrls] = useState({});

  const remember = useCallback((path, file, preview) => {
    if (!path || (!file && !preview?.startsWith("data:image/"))) return;
    const existing = filesRef.current.get(path);
    releasePreview(existing);
    // FileReader ha già letto il file compresso: il data URL sopravvive anche
    // quando il browser mobile invalida un object URL dopo la fotocamera.
    filesRef.current.set(path, preview?.startsWith("data:image/")
      ? preview : URL.createObjectURL(file));
    setUrls(Object.fromEntries(filesRef.current));
  }, []);

  const clear = useCallback(() => {
    filesRef.current.forEach(releasePreview);
    filesRef.current.clear();
    setUrls({});
  }, []);

  // Disponibile subito dopo remember(), prima ancora del render della nuova
  // mappa React: il path non deve mai cadere sul proxy prima del salvataggio.
  const get = useCallback((path) => filesRef.current.get(path), []);

  useEffect(() => () => {
    filesRef.current.forEach(releasePreview);
    filesRef.current.clear();
  }, []);

  return { urls, remember, clear, get };
};